MOVE.MORTGAGE.RATES.MESSAGE_VIEW = (function () {
  var $cardContainer = $('.mrtg-rate-card-container'),
    $helCardContainer = $('.hel-rate-card-container'),
    $facet = $('.card-search-facet'),
    $homeEquityEditButton = $('#edit-start'),
    $homeEquitySearchCancelButton = $facet.find('.hel-cancel-button'),
    $templatePath = 'templates/mortgage/',
    rdcTracking = window.RdcTracking,
    props;

  var init = function (_props) {
    props = _props;
    render();
  };

  var homeEquityInit = function(_props) {
    props = _props;
    homeEquityRender();
  };

  var homeEquityRender = function() {
    var content = JST[$templatePath + 'home_equity_rate_table_message']();
    $helCardContainer.append(content);
    $homeEquitySearchCancelButton.trigger('click');
    homeEquityBind();
  };

  var homeEquityBind = function() {
    $helCardContainer.find('.js-reset-search').on('click', function () {
      $homeEquityEditButton.trigger('click');
    });
  };

  var render = function () {
    let vu_logo_path = MOVE_DATA.vu_logo_path;
    let state = MOVE_DATA.state_page === undefined ? '' : '_state',
      loan_type = MOVE_DATA.loan_type === undefined ? '' : '_loan_type',
      city =  MOVE_DATA.city_page === undefined ? '' : '_city';
    let track_value = ['finance:rate_table_',props.search.purpose, state, loan_type,city, ':no_results_vu_ad:toll_free_number'].join('');
    let isPhone = MOVE.Helper.isMobileDevice() && MOVE.Helper.isPhone() !== null;
    let purpose = props.search.purpose;
    let amount = props.search.price - props.search.down_payment;
    let credit_score = props.search.credit_score;
    let zip = props.search.zip;
    var content = JST[$templatePath + 'rate_table_message']({
      isPhone,
      track_value,
      vu_logo_path,
      purpose,
      amount,
      credit_score,
      zip
    });
    $cardContainer.append(content);
    MOVE.Medias.gptTracking('LID_189226615', true);
    bindEventHandler();
  };

  var trackClick = function(linkName) {
    rdcTracking.trackEvent('click', { linkName });
  };

  var openSearchCriteria = function() {
    $('#edit-start, .js-edit-search').trigger('click');
    setTimeout(() => {
      $('#down-payment').focus()
    }, 600);
  };

  var getPageId = function() {
    return props.search.purpose === 'refinance'? 'rate_table_refinance': 'rate_table_purchase';
  };

  var bindEventHandler = function () {
    var pageId = getPageId();

    $('.search-criteria-widget').on('click', function () {
      openSearchCriteria();
      trackClick(`finance:${pageId}:no_result:search_criteria_widget`)
    });
    $('#home-loan-cta').on('click', function() {
      trackClick(`finance:${pageId}:no_result:home_loan_cta`)
    });
    $('#personal-loan-rates').on('click', function () {
      $("#personal-loan").modal();
      trackClick(`finance:${pageId}:no_result:personal_loan`)
    });

  };

  MOVE.MORTGAGE.RATES.MESSAGE_VIEW = {
    init: init,
    homeEquityInit: homeEquityInit
  };

  return MOVE.MORTGAGE.RATES.MESSAGE_VIEW;

})();



// WEBPACK FOOTER //
// ./mortgage/rates/views/message_view.js